import config from '@/config'
import { getQueryString } from '@/lib/utils'

function invoice(seq, name, userSeq) {
  let url = `${config.api.baseUri}/download/invoice/${seq}/${name}`

  if (userSeq) {
    url = `${config.api.baseUri}/download/${userSeq}/invoice/${seq}/${name}`
  }

  window.open(url, '_blank')
}

function invoiceUsage(seq, userSeq) {
  let url = `${config.api.baseUri}/download/invoice_usage/${seq}`

  if (userSeq) {
    url = `${config.api.baseUri}/download/${userSeq}/invoice_usage/${seq}`
  }

  document.location.href = url
}

function invoiceUsages(month, seqs) {
  const query = {
    month,
    seqs,
  }
  const url = `${config.api.baseUri}/download/invoice/usages?${getQueryString(
    query
  )}`

  document.location.href = url
}

function report(seq, name, userSeq) {
  let url = `${config.api.baseUri}/download/report/${seq}/${name}`

  if (userSeq) {
    url = `${config.api.baseUri}/download/${userSeq}/report/${seq}/${name}`
  }
  window.open(url, '_blank')
}

// 플랫폼별 개인정보처리방침 (gcp/alibaba: 메가존소프트, azure/tencent: 메가존클라우드)
const MZS_PRIVACY_POLICY_URL =
  'https://privacy.megazonesoft.com/production/mzs/privacy/index.html'
const MZC_PRIVACY_POLICY_URL =
  'https://privacy.megazone.com/production/mzc/privacy/index.html'
const PRIVACY_POLICY_URL = {
  gcp: MZS_PRIVACY_POLICY_URL,
  alibaba: MZS_PRIVACY_POLICY_URL,
  azure: MZC_PRIVACY_POLICY_URL,
  tencent: MZC_PRIVACY_POLICY_URL,
}

function privacyPolicy() {
  const url = PRIVACY_POLICY_URL[config.platform.id]

  window.open(url, '_blank', 'noopener')
}

export default {
  invoice,
  invoiceUsage,
  report,
  privacyPolicy,
  invoiceUsages,
}
